<template>
    <div class="landing-menu">
        <div class="landing-container wrap">
            <div class="left-side">
                <div class="logo-wrap" @click="$router.push('/')">
                    <img class="logo" src="@/assets/img/flypig.svg" alt="">
                    <span class="text">飛豬管家</span>
                </div>
                <div v-if="!isPolicyTerm" class="menu-wrap">
                    <ul>
                        <li><router-link :to="{ name: 'landlordLogin'}">個人房東</router-link></li>
                        <li><router-link :to="{ name: 'bizIntro'}">企業</router-link></li>
                        
                        <li><a href="https://www.fetuzbook.com/blog/">飛豬專欄</a></li>
                    </ul>
                </div>
            </div>
            <div class="right-side">
                <div v-if="isBizIntro" class="btn-group">
                    <div @click="$router.push({name: 'bizLogin'})" class="login">登入</div>
                    <div @click="$router.push({name: 'bizLogin', query: {'mode': 'register'}})" class="register">註冊</div>
                </div>
                <div v-else-if="isPolicyTerm"></div>
                <div v-else  class="download">
                    <div class="pc"  @mouseenter="showQr=true" @mouseleave="showQr=false">
                        App 下載
                        <download-app v-if="showQr"></download-app>
                    </div>
                    <div class="mb" v-scroll-to="'.landing-footer'">
                        App 下載
                    </div>
                </div>
                <!-- 漢堡按鈕 -->
                <div v-if="isMobile" class="hamburger" @click="toggleMenu">
                    <div :class="{ 'line': true, 'open': isMenuOpen }"></div>
                    <div :class="{ 'line': true, 'open': isMenuOpen }"></div>
                    <div :class="{ 'line': true, 'open': isMenuOpen }"></div>
                </div>
            </div>
            
        </div>
        <!-- 手機版選單 -->
        <div v-if="isMobile && isMenuOpen" class="mobile-menu">
            <ul>
                <li><router-link :to="{ name: 'landlordLogin'}">個人房東</router-link></li>
                <li><router-link :to="{ name: 'bizIntro'}">企業</router-link></li>
                <li><a href="https://www.fetuzbook.com/blog/">飛豬專欄</a></li>
            </ul>
        </div>
    </div>
</template>
<script>
import downloadApp from '@/components/officailPage/widges/tools/downloadApp.vue';

export default {
    data () {
        return {
            showQr: false,
            isMenuOpen: false, // 控制手機版選單展開/收起
            isMobile: false, 
        }
    },
    mounted() {
        this.handleResize(); // 初次加載時檢查螢幕尺寸
        window.addEventListener('resize', this.handleResize); // 監聽螢幕尺寸變化
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize); // 移除監聽
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 768; // 畫面寬度小於等於 768px 判定為手機版
        }
    },
    computed: {
        isBizIntro: function () {
            if( this.$route.name === 'bizIntro' ){
                return true
            }else{
                return false
            }
        },
        isPolicyTerm: function () {
            if( this.$route.name === 'userTerms' || this.$route.name === 'privacyPolicy'){
                return true
            }else{
                return false
            }
        }
    },
    components: {
        downloadApp
    }
}
</script>
<style lang="scss" scoped>
    .landing-menu{
        height: 68px;
        background-color: #28292d;
        display: flex;
        justify-content: center;
        .wrap{
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 911px;
            margin-left: auto;
            margin-right: auto;
            // margin-left: 174px;
            .left-side{
                display: flex;
                align-items: center;
                .logo-wrap{
                    position: relative;
                    display: flex;
                    align-items: center;
                    color: #fff;
                    font-size: 20px;
                    font-weight: 500;
                    padding-right: 27px;
                    margin-right: 22px;
                    cursor: pointer;
                    &::after{
                        content: '';
                        width: 1px;
                        height: 14px;
                        background: #6e6e6e;
                        position: absolute;
                        right: 0px;
                        top: 12px;
                    }
                    .logo{
                        width: 36px;
                        margin-right: 12px;
                    }
                }
                .menu-wrap{
                    color: #ffffff;
                    font-size: 18px;
                    >ul{
                        display: flex;
                        align-items: center;
                        >li{
                            color: #cad0d4;
                            margin-right: 29px;
                            cursor: pointer;
                            a{
                                position: relative;
                                padding: 0 7px;
                                color: #cad0d4;
                                &:hover{
                                    color: #6d7377;
                                }
                                &.router-link-active{
                                    color: #ff9275;
                                    &:after{
                                        content: '';
                                        position: absolute;
                                        display: block;
                                        height: 4px;
                                        width: 100%;
                                        bottom: -21px;
                                        border-radius: 4.5px;
                                        background-color: #ff9275;
                                    }
                                }
                            }
                            
                        }
                    }
                }
            }
            
            .download{
                position: relative;
                font-size: 18px;
                color: #ffffff;
                cursor: pointer;
                &:hover{
                    color: #6d7377;
                }
                >.mb{
                    display: none;
                }
            }
            .btn-group{
                position: relative;
                display: flex;
                align-items: center;
                .login{
                    font-size: 18px;
                    color: #ffffff;
                    margin-right: 58px;
                    cursor: pointer;
                }
                .register ,
                .register-now {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 115px;
                    height: 46px;
                    border-radius: 8px;
                    background-color: #fd9074;
                    font-size: 16px;
                    font-weight: 500;
                    color: #ffffff;
                    cursor: pointer;
                }
                .download {
                    position: relative;
                    font-size: 18px;
                    color: #ffffff;
                    right: 0;
                    cursor: pointer;
                    margin-right: 32px;
                }
            }
        }
        .hamburger {
            display: none;
            cursor: pointer;
            flex-direction: column;
            justify-content: space-between;
            width: 24px;
            height: 18px;
            margin-left: 14px;
            .line {
                width: 100%;
                height: 3px;
                background: #fff;
                transition: all 0.3s;
            }

            .line.open:nth-child(1) {
                transform: translateY(6px) rotate(45deg);
            }
            .line.open:nth-child(2) {
                opacity: 0;
            }
            .line.open:nth-child(3) {
                transform: translateY(-9px) rotate(-45deg);
            }
        }

        .mobile-menu {
            position: absolute;
            top: 68px;
            left: 0;
            width: 100%;
            background-color: #28292d;
            z-index: 1000;
            ul {
                display: flex;
                flex-direction: column;
                align-items: center;
                li {
                    border-bottom: solid 1px #6e6e6e;   
                    width: 100%;      
                    &::last-child {
                        border-bottom: none;
                    }   
                    a {
                        display: block;
                        padding: 20px 0;        
                        width: 100%;
                        text-align: center;
                        color: #cad0d4;
                        text-decoration: none;
                        font-size: 18px;
                        &:hover {
                            color: #ff9275;
                        }
                        &.router-link-active {
                            color: #ff9275;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1100px) {
         .landing-menu{
            .wrap{
                padding: 0 20px;
                width: 100%;
                margin-left: unset;
                .left-side{
                    .logo-wrap{
                        font-size: 20px;
                        padding-right: 19px;
                        margin-right: 8px;
                        &::after{
                            right: 0px;
                            top: 10px;
                        }
                        .logo{
                            width: 30px;
                            margin-right: 0px;
                        }
                        .text{
                            display: none;
                        }
                    }
                    .menu-wrap{
                        color: #ffffff;
                        font-size: 16px;
                        >ul{
                            display: flex;
                            align-items: center;
                            >li{
                                margin-right: 14px;
                                a{
                                    &.router-link-active{
                                        &:after{
                                            bottom: -22px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .download{
                    font-size: 16px;
                    >.pc{
                        display: none;
                    }
                    >.mb{
                        display: flex;
                    }
                }
                .btn-group{
                    .login{
                        font-size: 16px;
                        margin-right: 14px;
                    }
                    .register{
                        width: 62px;
                        height: 36px;
                        border-radius: 5px;
                        font-size: 16px;
                    }
                    .register-now {
                        width: 86px;
                        height: 36px;
                        border-radius: 5px;
                        font-size: 16px;
                    }
                    .download {
                        margin-right: 12px;
                    }
                }
                
            }
        }
    }
    @media screen and (max-width: 768px) {
        .landing-menu {
            .right-side {
                display: flex;
                align-items: center;
            }
            .wrap {
                .menu-wrap {
                    display: none;
                }
                .hamburger {
                    display: flex;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/widges/menu/menu.vue